// extracted by mini-css-extract-plugin
export default {"footer":"ConfirmationDialog-module__footer--uyinH","message":"ConfirmationDialog-module__message--egAi-"};